import { isDefined } from './miscUtils';

// group params by top level categories
export const parseCategories = (params, level = 0) => {
  return params.reduce((acc, param) => {
    const categoryName = param?.category?.[level] ?? '';

    if (!acc[categoryName]) {
      acc[categoryName] = { categoryName, params: [] };
    }

    acc[categoryName].params.push(param);
    return acc;
  }, {});
};

export const parseMCCategories = (params, level = 0) => {
  return params.reduce((acc, param) => {
    if (!param.mc_eligible) {
      return acc;
    }

    const categoryName = param?.category?.[level] ?? '';

    if (!acc[categoryName]) {
      acc[categoryName] = { categoryName, params: [] };
    }

    acc[categoryName].params.push(param);
    return acc;
  }, {});
};

export const getCategories = params => {
  const categorySet = params.reduce((acc, param) => {
    const categoryName = param?.category?.[0];

    if (categoryName) {
      acc.add(categoryName);
    }

    return acc;
  }, new Set());

  return Array.from(categorySet);
};

export const resolveParamName = (paramName, index, parentName) =>
  parentName ? `${parentName}${isDefined(index) ? `.${index}` : ''}.${paramName}` : paramName;

export const transformGroupdFieldValues = (values, schemas) => {
  if (!values) return null;

  const result = {};

  for (const [key, value] of Object.entries(values)) {
    if (value == null || Number.isNaN(value) || value === undefined) {
      continue;
    }

    const schema = schemas.find(s => s.name === key);

    if (schema?.type === 'group' && schema.params) {
      const nested = transformGroupdFieldValues(value, schema.params);
      if (Object.keys(nested)?.length) {
        result[key] = { params: nested };
      }
    } else if (schema && schema.editable && value !== '') {
      result[key] = { primary: { value } };
    }
  }
  return result;
};

export const hasLocationScalingEnable = param => {
  return param?.params?.location_scaling_enabled;
};

export const isLocationScalingEnabled = param => {
  return param?.params?.location_scaling_enabled?.primary?.value === true;
};

export const findLocationScalingSchema = paramSchema => {
  return paramSchema?.params?.find(p => p.name === 'location_scaling_enabled');
};
